import '/opt/actions-runner/_work/crate/crate/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "wide11": "registration-53018bea-wide11-WXUgJq",
  "default5": "registration-53018bea-default5-WXUgJq",
  "tinyOffset10": "registration-53018bea-tinyOffset10-WXUgJq",
  "confined7": "registration-53018bea-confined7-WXUgJq",
  "xwide4": "registration-53018bea-xwide4-WXUgJq",
  "defaultOffset11": "registration-53018bea-defaultOffset11-WXUgJq",
  "xwideOffset8": "registration-53018bea-xwideOffset8-WXUgJq",
  "tiny6": "registration-53018bea-tiny6-WXUgJq",
  "tinyOffset7": "registration-53018bea-tinyOffset7-WXUgJq",
  "confined8": "registration-53018bea-confined8-WXUgJq",
  "confined11": "registration-53018bea-confined11-WXUgJq",
  "wide6": "registration-53018bea-wide6-WXUgJq",
  "default10": "registration-53018bea-default10-WXUgJq",
  "tiny4": "registration-53018bea-tiny4-WXUgJq",
  "xwide1": "registration-53018bea-xwide1-WXUgJq",
  "xwideOffset2": "registration-53018bea-xwideOffset2-WXUgJq",
  "tinyOffset0": "registration-53018bea-tinyOffset0-WXUgJq",
  "wide9": "registration-53018bea-wide9-WXUgJq",
  "tiny3": "registration-53018bea-tiny3-WXUgJq",
  "standardGridContainer": "registration-53018bea-standardGridContainer-WXUgJq",
  "wideOffset10": "registration-53018bea-wideOffset10-WXUgJq",
  "confinedOffset8": "registration-53018bea-confinedOffset8-WXUgJq",
  "default2": "registration-53018bea-default2-WXUgJq",
  "xwide6": "registration-53018bea-xwide6-WXUgJq",
  "wideOffset2": "registration-53018bea-wideOffset2-WXUgJq",
  "wideOffset4": "registration-53018bea-wideOffset4-WXUgJq",
  "default11": "registration-53018bea-default11-WXUgJq",
  "defaultOffset4": "registration-53018bea-defaultOffset4-WXUgJq",
  "xwide0": "registration-53018bea-xwide0-WXUgJq",
  "defaultOffset3": "registration-53018bea-defaultOffset3-WXUgJq",
  "tiny1": "registration-53018bea-tiny1-WXUgJq",
  "defaultOffset10": "registration-53018bea-defaultOffset10-WXUgJq",
  "xwideOffset7": "registration-53018bea-xwideOffset7-WXUgJq",
  "tinyOffset4": "registration-53018bea-tinyOffset4-WXUgJq",
  "xwideOffset10": "registration-53018bea-xwideOffset10-WXUgJq",
  "wideGridContainer": "registration-53018bea-wideGridContainer-WXUgJq",
  "default7": "registration-53018bea-default7-WXUgJq",
  "col": "registration-53018bea-col-WXUgJq",
  "default3": "registration-53018bea-default3-WXUgJq",
  "tinyOffset8": "registration-53018bea-tinyOffset8-WXUgJq",
  "confined12": "registration-53018bea-confined12-WXUgJq",
  "confinedOffset7": "registration-53018bea-confinedOffset7-WXUgJq",
  "xwideOffset9": "registration-53018bea-xwideOffset9-WXUgJq",
  "tiny11": "registration-53018bea-tiny11-WXUgJq",
  "xwideOffset3": "registration-53018bea-xwideOffset3-WXUgJq",
  "confinedOffset4": "registration-53018bea-confinedOffset4-WXUgJq",
  "wide8": "registration-53018bea-wide8-WXUgJq",
  "default0": "registration-53018bea-default0-WXUgJq",
  "xwide8": "registration-53018bea-xwide8-WXUgJq",
  "xwideOffset5": "registration-53018bea-xwideOffset5-WXUgJq",
  "confined5": "registration-53018bea-confined5-WXUgJq",
  "wide3": "registration-53018bea-wide3-WXUgJq",
  "confinedOffset2": "registration-53018bea-confinedOffset2-WXUgJq",
  "wide1": "registration-53018bea-wide1-WXUgJq",
  "xwideOffset11": "registration-53018bea-xwideOffset11-WXUgJq",
  "tiny8": "registration-53018bea-tiny8-WXUgJq",
  "wide2": "registration-53018bea-wide2-WXUgJq",
  "confinedOffset0": "registration-53018bea-confinedOffset0-WXUgJq",
  "tiny5": "registration-53018bea-tiny5-WXUgJq",
  "wide4": "registration-53018bea-wide4-WXUgJq",
  "wide10": "registration-53018bea-wide10-WXUgJq",
  "defaultOffset5": "registration-53018bea-defaultOffset5-WXUgJq",
  "defaultOffset1": "registration-53018bea-defaultOffset1-WXUgJq",
  "tinyOffset2": "registration-53018bea-tinyOffset2-WXUgJq",
  "confinedOffset3": "registration-53018bea-confinedOffset3-WXUgJq",
  "tiny0": "registration-53018bea-tiny0-WXUgJq",
  "gridContainer": "registration-53018bea-gridContainer-WXUgJq",
  "confinedOffset9": "registration-53018bea-confinedOffset9-WXUgJq",
  "default1": "registration-53018bea-default1-WXUgJq",
  "tiny12": "registration-53018bea-tiny12-WXUgJq",
  "confined9": "registration-53018bea-confined9-WXUgJq",
  "wide12": "registration-53018bea-wide12-WXUgJq",
  "wide5": "registration-53018bea-wide5-WXUgJq",
  "wideOffset9": "registration-53018bea-wideOffset9-WXUgJq",
  "confined6": "registration-53018bea-confined6-WXUgJq",
  "xwide9": "registration-53018bea-xwide9-WXUgJq",
  "armstrongGridContainer": "registration-53018bea-armstrongGridContainer-WXUgJq",
  "xwide10": "registration-53018bea-xwide10-WXUgJq",
  "wide7": "registration-53018bea-wide7-WXUgJq",
  "confinedOffset11": "registration-53018bea-confinedOffset11-WXUgJq",
  "xwideOffset1": "registration-53018bea-xwideOffset1-WXUgJq",
  "default8": "registration-53018bea-default8-WXUgJq",
  "wideOffset3": "registration-53018bea-wideOffset3-WXUgJq",
  "xwide2": "registration-53018bea-xwide2-WXUgJq",
  "wideOffset7": "registration-53018bea-wideOffset7-WXUgJq",
  "tiny2": "registration-53018bea-tiny2-WXUgJq",
  "xwide3": "registration-53018bea-xwide3-WXUgJq",
  "tiny9": "registration-53018bea-tiny9-WXUgJq",
  "default4": "registration-53018bea-default4-WXUgJq",
  "tinyOffset6": "registration-53018bea-tinyOffset6-WXUgJq",
  "defaultOffset8": "registration-53018bea-defaultOffset8-WXUgJq",
  "default9": "registration-53018bea-default9-WXUgJq",
  "wideOffset8": "registration-53018bea-wideOffset8-WXUgJq",
  "default6": "registration-53018bea-default6-WXUgJq",
  "confined0": "registration-53018bea-confined0-WXUgJq",
  "confinedOffset6": "registration-53018bea-confinedOffset6-WXUgJq",
  "defaultOffset2": "registration-53018bea-defaultOffset2-WXUgJq",
  "wideOffset6": "registration-53018bea-wideOffset6-WXUgJq",
  "xwide5": "registration-53018bea-xwide5-WXUgJq",
  "defaultOffset7": "registration-53018bea-defaultOffset7-WXUgJq",
  "xwideOffset6": "registration-53018bea-xwideOffset6-WXUgJq",
  "confined1": "registration-53018bea-confined1-WXUgJq",
  "tinyOffset9": "registration-53018bea-tinyOffset9-WXUgJq",
  "confined10": "registration-53018bea-confined10-WXUgJq",
  "confinedOffset1": "registration-53018bea-confinedOffset1-WXUgJq",
  "tinyOffset3": "registration-53018bea-tinyOffset3-WXUgJq",
  "default12": "registration-53018bea-default12-WXUgJq",
  "wide0": "registration-53018bea-wide0-WXUgJq",
  "confinedOffset10": "registration-53018bea-confinedOffset10-WXUgJq",
  "xwideOffset0": "registration-53018bea-xwideOffset0-WXUgJq",
  "tinyOffset1": "registration-53018bea-tinyOffset1-WXUgJq",
  "tinyOffset5": "registration-53018bea-tinyOffset5-WXUgJq",
  "confinedOffset5": "registration-53018bea-confinedOffset5-WXUgJq",
  "wideOffset11": "registration-53018bea-wideOffset11-WXUgJq",
  "xwide11": "registration-53018bea-xwide11-WXUgJq",
  "row": "registration-53018bea-row-WXUgJq",
  "tiny7": "registration-53018bea-tiny7-WXUgJq",
  "confined4": "registration-53018bea-confined4-WXUgJq",
  "wideOffset1": "registration-53018bea-wideOffset1-WXUgJq",
  "tinyOffset11": "registration-53018bea-tinyOffset11-WXUgJq",
  "grid": "registration-53018bea-grid-WXUgJq",
  "confined3": "registration-53018bea-confined3-WXUgJq",
  "xwide7": "registration-53018bea-xwide7-WXUgJq",
  "defaultOffset6": "registration-53018bea-defaultOffset6-WXUgJq",
  "wideOffset0": "registration-53018bea-wideOffset0-WXUgJq",
  "confined2": "registration-53018bea-confined2-WXUgJq",
  "xwide12": "registration-53018bea-xwide12-WXUgJq",
  "tiny10": "registration-53018bea-tiny10-WXUgJq",
  "defaultOffset9": "registration-53018bea-defaultOffset9-WXUgJq",
  "wideOffset5": "registration-53018bea-wideOffset5-WXUgJq",
  "xwideOffset4": "registration-53018bea-xwideOffset4-WXUgJq"
};